// 导入 element-ui的 Message
import { Message } from "element-ui";
// import { apiUserDetail } from "@/api/user.js";
import { apiSystemLogDetail, apProcessLogDetail } from "@/api/systemLog.js";
import domtoimage from 'dom-to-image';
import { apiDownloadFile } from "@/api/filesUpload.js";

let myPlugin = {}
myPlugin.install = function (Vue) {
	// let isCanvasDownload = true;
	// 更多查询表单样式调整
	Vue.prototype.$moreSearchStyle = () => {
		Vue.nextTick(() => {
			document.querySelector(".contentBox").style.top =
				document.querySelector(".header").offsetHeight + "px";
		});
	}
	// 删除等操作需验证名称
	Vue.prototype.$allOperation = function (data, mode, type) {
		// 设置删除的提示内容
		const h = this.$createElement;
		return this.$msgbox({
			title: `${mode}${type}`,
			message: h("div", null, [
				h("span", null, `输入完整的${type}:【`),
				h("i", { style: "color: var(--themeColor)" }, data.name),
				h("span", null, `】以确认${mode}！`)
			]),
			showCancelButton: true,
			confirmButtonText: `确定${mode}`,
			cancelButtonText: "取消",
			closeOnClickModal: false,
			showInput: true,
			beforeClose: (action, instance, done) => {
				if (action === 'confirm') {
					if (instance.inputValue === data.name) {
						done()
					} else {
						Message({
							type: "warning",
							message: `输入错误，无法${mode}！`
						})
					}
				} else {
					done()
				}
			}
		})
	}
	// Vue.prototype.$allUserDetail = async function (data) {
	// 	// console.log(data)
	// 	if (data.id != 0) {
	// 		const res = await apiUserDetail({
	// 			id: data.id
	// 		})
	// 		// console.log(res)
	// 		if (res.code == 0) {
	// 			const h = this.$createElement;
	// 			return this.$notify({
	// 				title: "用户信息",
	// 				message: h("p", null, [
	// 					h("p", null, [
	// 						h("span", null, "工号："),
	// 						h("span", null, res.data.employeeNum || '-')
	// 					]),
	// 					h("p", null, [
	// 						h("span", null, "姓名："),
	// 						h("span", null, res.data.name)
	// 					]),
	// 					h("p", null, [
	// 						h("span", null, "手机："),
	// 						h("span", null, res.data.phone || '-')
	// 					]),
	// 					h("p", null, [
	// 						h("span", null, "短号："),
	// 						h("span", null, res.data.shortPhone || '-')
	// 					]),
	// 					h("p", null, [
	// 						h("span", null, "邮箱："),
	// 						h("span", null, res.data.email || '-')
	// 					]),
	// 					h("p", null, [
	// 						h("span", null, "岗位："),
	// 						h("span", null, res.data.position ? res.data.position.name : '-')
	// 					]),
	// 					h("p", null, [
	// 						h("span", null, "子部门："),
	// 						h("span", null, res.data.dept ? res.data.dept.name : '-')
	// 					]),
	// 					h("p", null, [
	// 						h("span", null, "事业部："),
	// 						h("span", null, res.data.division ? res.data.division.name : '-')
	// 					]),
	// 				]),
	// 				customClass: 'userDetailNotify',
	// 				// duration: 0
	// 			});
	// 		}
	// 	}
	// }
	// 操作日志详情
	Vue.prototype.$systemLogDetail = async function (row) {
		// console.log(data)
		const res = await apiSystemLogDetail({
			id: row.id
		})
		// console.log(res)
		if (res.code == 0) {
			operationDetailMore(".systemLogDetail")
			const h = this.$createElement;
			return this.$notify({
				title: "操作详情",
				message: h("div", null, [
					h("div", null, [
						h("span", null, "Request ID："),
						h("span", null, res.data.id)
					]),
					h("div", null, [
						h("span", null, "操作："),
						h("span", null, res.data.action)
					]),
					h("div", null, [
						h("span", null, "URI："),
						h("span", null, res.data.uri)
					]),
					h("div", null, [
						h("span", null, "APP："),
						h("span", null, res.data.app ? res.data.app : '-')
					]),
					h("div", null, [
						h("span", null, "版本："),
						h("span", null, res.data.appVer ? res.data.appVer + ' Build ' + res.data.appBuild : '-')
					]),
					h("div", null, [
						h("span", null, "请求时间："),
						h("span", null, res.data.requestDateTime)
					]),
					h("div", null, [
						h("span", null, "请求参数："),
						h("div", null, [
							h("div", { 'class': "jsonTextRequestOne" }, res.data.requestData ? JSON.stringify(res.data.requestData) : '-'),
							h("pre", { 'class': "jsonTextRequestTwo" }, res.data.requestData ? JSON.stringify(res.data.requestData, null, '\t') : '-')
						]),
					]),
					h("div", null, [
						h("span", null, "错误代码："),
						h("span", null, res.data.returnCode)
					]),
					h("div", null, [
						h("span", null, "返回信息："),
						h("span", null, res.data.returnMsg ? res.data.returnMsg : '-')
					]),
					h("div", null, [
						h("span", null, "返回时间："),
						h("span", null, res.data.returnDateTime ? res.data.returnDateTime : '-')
					]),
					h("div", null, [
						h("span", null, "返回值："),
						h("div", null, [
							h("div", { 'class': "jsonTextReturnOne" }, res.data.returnData ? JSON.stringify(res.data.returnData) : '-'),
							h("pre", { 'class': "jsonTextReturnTwo" }, res.data.returnData ? JSON.stringify(res.data.returnData, null, '\t') : '-')
						]),
					]),
					h("div", null, [
						h("span", null, "客户端："),
						h("span", null, row.app ? `${row.app} ${row.appVer}(${row.appBuild})` : '-')
					]),
				]),
				customClass: 'systemLogDetail',
				// duration: 0
			});
		}
	}
	// 生产日志详情
	Vue.prototype.$processLogDetail = async function (row) {
		const res = await apProcessLogDetail({
			id: row.id
		})
		// console.log(res)
		if (res.code == 0) {
			operationDetailMore(".processDetail")
			const h = this.$createElement;
			return this.$notify({
				title: "操作详情",
				message: h("div", null, [
					h("div", null, [
						h("span", null, "Request ID："),
						h("span", null, res.data.id)
					]),
					h("div", null, [
						h("span", null, "Key："),
						h("span", null, res.data.key ? res.data.key : "-")
					]),
					h("div", null, [
						h("span", null, "工单类型："),
						h("span", null, res.data.orderType.type)
					]),
					h("div", null, [
						h("span", null, "工单："),
						h("span", null, res.data.order ? res.data.order.orderNumber : "-")
					]),
					h("div", null, [
						h("span", null, "线体："),
						h("span", null, res.data.organization ? res.data.organization.name : "-")
					]),
					h("div", null, [
						h("span", null, "工序："),
						h("span", null, res.data.workStation ? res.data.workStation.name : "-")
					]),
					h("div", null, [
						h("span", null, "用户："),
						h("span", null, res.data.user ? res.data.user.name : "-")
					]),
					h("div", null, [
						h("span", null, "请求IP："),
						h("span", null, res.data.requestIp)
					]),
					h("div", null, [
						h("span", null, "请求时间："),
						h("span", null, res.data.requestDateTime)
					]),
					h("div", null, [
						h("span", null, "请求参数："),
						h("div", null, [
							h("div", { 'class': "jsonTextRequestOne" }, res.data.requestData ? JSON.stringify(res.data.requestData) : '-'),
							h("pre", { 'class': "jsonTextRequestTwo" }, res.data.requestData ? JSON.stringify(res.data.requestData, null, '\t') : '-')
						]),
					]),
					h("div", null, [
						h("span", null, "错误代码："),
						h("span", null, res.data.returnCode)
					]),
					h("div", null, [
						h("span", null, "返回信息："),
						h("span", null, res.data.returnMsg ? res.data.returnMsg : '-')
					]),
					h("div", null, [
						h("span", null, "返回时间："),
						h("span", null, res.data.returnDateTime ? res.data.returnDateTime : '-')
					]),
					h("div", null, [
						h("span", null, "返回值："),
						h("div", null, [
							h("div", { 'class': "jsonTextReturnOne" }, res.data.returnData ? JSON.stringify(res.data.returnData) : '-'),
							h("pre", { 'class': "jsonTextReturnTwo" }, res.data.returnData ? JSON.stringify(res.data.returnData, null, '\t') : '-')
						]),
					])
				]),
				customClass: 'processDetail',
				// duration: 0
			});
		}
	}
	// 错误日志详情
	Vue.prototype.$errorLogDetail = async function (row) {
		// console.log(row)
		if (row.existsActionLog) {
			const res = await apiSystemLogDetail({
				id: row.id
			})
			// console.log(res)
			if (res.code == 0) {
				operationDetailMore(".errorLogDetail")
				const h = this.$createElement;
				return this.$notify({
					title: "操作详情",
					message: h("div", null, [
						h("div", null, [
							h("span", null, "Request ID："),
							h("span", null, res.data.id)
						]),
						h("div", null, [
							h("span", null, "操作："),
							h("span", null, res.data.action)
						]),
						h("div", null, [
							h("span", null, "URI："),
							h("span", null, res.data.uri)
						]),
						h("div", null, [
							h("span", null, "APP："),
							h("span", null, res.data.app ? res.data.app : '-')
						]),
						h("div", null, [
							h("span", null, "版本："),
							h("span", null, res.data.appVer ? res.data.appVer + ' Build ' + res.data.appBuild : '-')
						]),
						h("div", null, [
							h("span", null, "请求时间："),
							h("span", null, res.data.requestDateTime)
						]),
						h("div", null, [
							h("span", null, "请求参数："),
							h("div", null, [
								h("div", { 'class': "jsonTextRequestOne" }, res.data.requestData ? JSON.stringify(res.data.requestData) : '-'),
								h("pre", { 'class': "jsonTextRequestTwo" }, res.data.requestData ? JSON.stringify(res.data.requestData, null, '\t') : '-')
							]),
						]),
						h("div", null, [
							h("span", null, "错误代码："),
							h("span", null, res.data.returnCode)
						]),
						h("div", null, [
							h("span", null, "返回信息："),
							h("span", null, res.data.returnMsg ? res.data.returnMsg : '-')
						]),
						h("div", null, [
							h("span", null, "返回时间："),
							h("span", null, res.data.returnDateTime ? res.data.returnDateTime : '-')
						]),
						h("div", null, [
							h("span", null, "返回值："),
							h("div", null, [
								h("div", { 'class': "jsonTextReturnOne" }, res.data.returnData ? JSON.stringify(res.data.returnData) : '-'),
								h("pre", { 'class': "jsonTextReturnTwo" }, res.data.returnData ? JSON.stringify(res.data.returnData, null, '\t') : '-')
							]),
						]),
						h("div", null, [
							h("span", null, "客户端："),
							h("span", null, row.app ? `${row.app} ${row.appVer}(${row.appBuild})` : '-')
						]),
						h("div", null, [
							h("span", null, "UserAgent："),
							h("div", null, [
								h("div", { 'class': "jsonTextReturnOne" }, row.userAgent ? row.userAgent : '-'),
								h("div", { 'class': "jsonTextReturnTwo" }, row.userAgent ? row.userAgent : '-')
							]),
						]),
					]),
					customClass: 'errorLogDetail'
				});
			}
		} else {
			operationDetailMore(".errorLogDetail")
			const h = this.$createElement;
			return this.$notify({
				title: "操作详情",
				message: h("div", null, [
					h("div", null, [
						h("span", null, "Request ID："),
						h("span", null, row.id)
					]),
					h("div", null, [
						h("span", null, "操作："),
						h("span", null, row.action)
					]),
					h("div", null, [
						h("span", null, "URI："),
						h("span", null, row.uri)
					]),
					h("div", null, [
						h("span", null, "APP："),
						h("span", null, row.app ? row.app : '-')
					]),
					h("div", null, [
						h("span", null, "版本："),
						h("span", null, row.appVer ? row.appVer + ' Build ' + row.appBuild : '-')
					]),
					h("div", null, [
						h("span", null, "操作时间："),
						h("span", null, row.createDateTime)
					]),
					h("div", null, [
						h("span", null, "错误代码："),
						h("span", null, row.errorCode)
					]),
					h("div", null, [
						h("span", null, "错误信息："),
						h("div", null, [
							h("div", { 'class': "jsonTextReturnOne" }, row.errorMsg ? row.errorMsg : '-'),
							h("div", { 'class': "jsonTextReturnTwo" }, row.errorMsg ? row.errorMsg : '-')
						]),
					]),
					h("div", null, [
						h("span", null, "错误栈："),
						h("div", null, [
							h("div", { 'class': "jsonTextReturnOne" }, row.errorStack ? JSON.stringify(row.errorStack) : '-'),
							h("pre", { 'class': "jsonTextReturnTwo" }, row.errorStack ? JSON.stringify(row.errorStack, null, '\t') : '-')
						]),
					]),
					h("div", null, [
						h("span", null, "客户端："),
						h("span", null, row.app ? `${row.app} ${row.appVer}(${row.appBuild})` : '-')
					]),
					h("div", null, [
						h("span", null, "UserAgent："),
						h("div", null, [
							h("div", { 'class': "jsonTextReturnOne" }, row.userAgent ? row.userAgent : '-'),
							h("div", { 'class': "jsonTextReturnTwo" }, row.userAgent ? row.userAgent : '-')
						]),
					]),
				]),
				customClass: 'errorLogDetail',

			});
		}
	}
	// 工序配置详情
	Vue.prototype.$workStationDetail = async function (row) {
		operationDetailMore(".workStationDetail")
		const h = this.$createElement;
		return this.$notify({
			title: "配置详情",
			message: h("div", null, [
				h("div", null, [
					h("span", null, "工序配置："),
					h("div", null, [
						h("div", { 'class': "jsonTextReturnOne" }, row ? JSON.stringify(row) : '-'),
						h("pre", { 'class': "jsonTextReturnTwo" }, row ? JSON.stringify(row, null, '\t') : '-')
					])]
				),
			]),
			customClass: 'workStationDetail',
		});
	}
	// 格式数值为正负整数
	Vue.prototype.$formatPositive = function (value) {
		// console.log(value)
		if (value.length == 1) {
			value = value.replace(/[^-\d]/gi, "");
		} else {
			value =
				value.substring(0, 1) +
				value.substring(1, value.length).replace(/[^\d]/gi, "");
		}
		if (!(/[-\d]/.test(value[0]))) {
			value = value.substring(1, value.length)
		}
		return value
	}
	// 格式数值允许一位小数
	Vue.prototype.$formatDecimals = function (value) {
		return value.replace(/^\D*(\d*(?:\.\d{0,1})?).*$/g, '$1')
	}
	// 局部图片下载
	Vue.prototype.$canvasDownload = function (selector, downloadName) {
		let dom = document.querySelector(selector)
		domtoimage.toJpeg(dom, {
			bgcolor: "#fff",
			quality: 0.95
		}).then(function (dataUrl) {
			let a = document.createElement('a');
			a.href = dataUrl;
			a.download = downloadName;
			a.target = "_blank";
			a.style.display = "none";
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		});
	}
	// url下载
	Vue.prototype.$downloadFile = function (fid, fileName, secretKey) {
		let uri = apiDownloadFile(fid, secretKey);
		let a = document.createElement("a");		
		a.href = uri;
		a.download = fileName;
		a.target = "_blank";
		a.style.display = "none";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
}
// 点击蓝色字体展开内容处理
function operationDetailMore(eleName) {
	setTimeout(() => {
		let operationDetailDom,
			jsonTextRequestOneAll = document.querySelectorAll(
				".jsonTextRequestOne"
			),
			jsonTextRequestTwoAll = document.querySelectorAll(
				".jsonTextRequestTwo"
			),
			jsonTextReturnOneAll = document.querySelectorAll(
				".jsonTextReturnOne"
			),
			jsonTextReturnTwoAll = document.querySelectorAll(
				".jsonTextReturnTwo"
			);
		jsonTextRequestOneAll.forEach((item, index) => {
			item.onclick = () => {
				operationDetailDom = document.querySelectorAll(eleName)
				item.style.display = "none";
				jsonTextRequestTwoAll[index].style.display = "block";
				for (let index = 1; index < operationDetailDom.length; index++) {
					operationDetailDom[index].style.top = operationDetailDom[index - 1].offsetHeight + parseInt(operationDetailDom[index - 1].style.top) + 16 + 'px'
				}
			};
		});
		jsonTextReturnOneAll.forEach((item, index) => {
			item.onclick = () => {
				operationDetailDom = document.querySelectorAll(eleName)
				item.style.display = "none";
				jsonTextReturnTwoAll[index].style.display = "block";
				for (let index = 1; index < operationDetailDom.length; index++) {
					operationDetailDom[index].style.top = operationDetailDom[index - 1].offsetHeight + parseInt(operationDetailDom[index - 1].style.top) + 16 + 'px'
				}
			};
		});
	}, 500);
}
// 验证值是否为json格式字符串
// function verifyJSON(value) {
// 	try {
// 		JSON.parse(value);
// 		return JSON.stringify(JSON.parse(value), null, '\t')
// 	} catch {
// 		return value
// 	}
// }
export default myPlugin